export const blogUrl = 'https://bloging-feature.vercel.app';
// Define the email addresses of blog administrators
export const blogAdmins = ['shivamsingh.comp1999@gmail.com','pcutilitiespro1@gmail.com'];
